<script setup lang="ts">
import CircularProgress from '@/uiKit/CircularProgress.vue'
import { ref } from 'vue'

defineProps<{
  url: string
}>()

const loaded = ref(false)
</script>

<template>
  <div
    class="go-scrollbar h-full w-full overflow-auto px-1.5 pb-2 text-sm-12px-light whitespace-normal text-text"
  >
    <div
      v-if="!loaded"
      class="flex size-full items-center justify-center"
    >
      <CircularProgress />
    </div>
    <iframe
      data-theme="dark"
      sandbox=""
      class="h-full w-full bg-surface-primary-inverted"
      :src="url"
      @load="loaded = true"
    />
  </div>
</template>
